import { Component, DestroyRef, inject, ViewChild } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { TaskPanelService } from './task-panel.service';
import { MatIconModule } from '@angular/material/icon';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { AccordionModule } from 'primeng/accordion';
import { SkeletonModule } from 'primeng/skeleton';
import { SecurityService } from 'src/services/security/security.service';
import { FuncionesService } from '../funciones-service';
import { UserCirclesComponent, UserChangeEvent, ResourceUser } from "../../../../../../components/user-circles/user-circles.component";

import { ApiService } from 'src/services/api.service';
import { LoadingService } from 'src/services/loading.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { forkJoin } from 'rxjs';


type PeopleType = {
	dataName: string,
	photo: string,
}
type ResourceType = {
	people: PeopleType,
	resource: boolean,
	mainResource: boolean,
	owner: boolean,
}
type SmartDocType = {
	fileName: string,
	fileStatus: string,
	fileURL: string,
	category: string,
}
type TaskType = {
	id: number,
	uuid: string,
	taskName: string,
	groupName: string,
	data: string,
	status: string,
	taskType: string,
	parentTaskId: number,
	// taskOwner: ResourceType
	resources: ResourceType[],
	listSmartDocs: SmartDocType[],
	fromPredecesor: boolean
}
type ProjectType = {
	id: number,
	name: string,
	listVOTasks: TaskType[]
};
type TreeNodeType = {
	id: number,
	sequence: number,
	isProject: boolean,
	isTask: boolean,
	isGroup: boolean,
	hiddenGroupName: boolean,
	name: string,
	groupName: string,
	status: string,
	children: TreeNodeType[]
};
type FinancialDataType = {
	groupName: string,
	headerLabel: string,
	label: string,
	projectId: number,
	taskId: number,
	data: string,
	organizationId: number,
	financialData: number
};
type GroupFinancialDataType = {
	headerLabel: string,
	listFinancialData: FinancialDataType[],
	total: number
};
type ProjectDetailType = {
	position: number,
	detail: string
};
type ActionType = {
	actionURL: string,
	label: string
};
type TaskDetailType = {
	key: string,
	value: string,
	url: string,
	label: string,
	list: KVType[],
	type: string,
};
type KVType = {
	key: string,
	value: string,
};

@Component({
	selector: 'vex-task-panel',
	standalone: true,
	imports: [
		MatDividerModule,
		MatListModule,
		MatRippleModule,
		MatProgressBarModule,
		MatIconModule,
		NgClass,
		NgFor,
		NgIf,
		ReactiveFormsModule,
		MatTooltipModule,
		MatSelectModule,
		MatButtonModule,
		AccordionModule,
		SkeletonModule,
		UserCirclesComponent
		],
	templateUrl: './task-panel.component.html',
	styleUrl: './task-panel.component.scss'
})
export class TaskPanelOldComponent {
	private readonly destroyRef = inject(DestroyRef);

	@ViewChild(UserCirclesComponent) userCirclesComponent: UserCirclesComponent;

	task;
	taskId;
	form = this.fb.group({
		users: this.fb.control([]),
	});
	users;

	listAllSmartDocs: SmartDocType[] = [];
	listFileSmartDocs: SmartDocType[] = [];
	listDeliveryfileSmartDocs: SmartDocType[] = [];
	listActions: ActionType[] = [];
	listTaskDetails: TaskDetailType[] = [];
	detailsResources: ResourceType[] = [];
	detailsName: string = '';

	constructor(
		protected taskPanelService: TaskPanelService,
		private fb: FormBuilder,
		protected securityService: SecurityService,
		private funcionesService: FuncionesService,
		private apiService: ApiService,
		private loadingService: LoadingService,
		private snackBar: MatSnackBar,
	) { }

	ngOnInit() {
		this.task = this.taskPanelService.getData();
		this.users = this.task.resources;
		// console.log('Task:', this.task);
		// this.taskId = this.ta
		this.filterSmartdocs();

		if (this.securityService.securityObject.canUseTaskActions) {
			if (this.task.status == 'Active') {
				if (this.task.taskType == 'GenericReview') {
					this.listActions.push({ actionURL: 'forceTask', label: 'Force send email' });
					if (this.task.taskName.includes('Adaptation')) {
						this.listActions.push({ actionURL: 'exportScreenplayTask', label: 'Create export screenplay task' });
					}
				} else if (this.task.taskType.includes('Workflow')) {
					this.listActions.push({ actionURL: 'forceTask', label: 'Force workflow' });
				} else if (this.task.taskType == 'GenerateSRT') {
					this.listActions.push({ actionURL: 'forceTask', label: 'Force SRT' });
				} else if (this.task.taskType == 'TextNormalize') {
					this.listActions.push({ actionURL: 'forceTask', label: 'Force normalization' });
				} else if (this.task.taskType == 'Translation') {
					this.listActions.push({ actionURL: 'forceTask', label: 'Force translation' });
				} else if (this.task.taskType == 'GenerateAudio') {
					this.listActions.push({ actionURL: 'forceTask', label: 'Force generate audio' });
				} else if (this.task.taskType == 'ExportToExcel') {
					this.listActions.push({ actionURL: 'forceTask', label: 'Force generate export' });
				} else if (this.task.taskType == 'VideoToMP4') {
					this.listActions.push({ actionURL: 'forceTask', label: 'Force video to MP4' });
				} else if (this.task.taskType == 'SpeechToText') {
					this.listActions.push({ actionURL: 'forceTask', label: 'Force Speech to text' });
				} else {
					this.listActions.push({ actionURL: 'forceTask2', label: 'Force Task' });
				}
				// } else if (this.task.status == 'Cancelled') {
				// 	this.listActions.push({actionURL:'cancelTask', label:'Cancel cascading tasks'});
			} else if (this.task.status == 'Failed') {
				this.listActions.push({ actionURL: 'forceTask', label: 'Retry task' });
			} else if (this.task.status == 'On-Hold') {
				this.listActions.push({ actionURL: 'cancelTask', label: 'Cancel cascading tasks' });
			} else if (this.task.status == 'Completed') {
				if (this.task.taskType == 'SendMailDelivery') {
					this.listActions.push({ actionURL: 'forceSendEmail', label: 'Force send email' });
					// } else if (this.task.taskType == 'GenericReview') {
					// 	this.listActions.push({actionURL:'forceBackTask2', label:'Force to this point'});
					// } else if (this.task.taskType == 'Translation') {
					// 	this.listActions.push({actionURL:'forceBackTask2', label:'Force to this point'});
					// } else if (this.task.taskType == 'GenerateAudio') {
					// 	this.listActions.push({actionURL:'forceBackTask2', label:'Force to this point'});
					// } else if (this.task.taskType == 'SpeechToText') {
					// 	this.listActions.push({actionURL:'forceBackTask2', label:'Force to this point'});
					// } else if (this.task.taskType == 'TextNormalize') {
					// 	this.listActions.push({actionURL:'forceBackTask2', label:'Force to this point'});
					// } else if (this.task.taskType == 'VideoToMP4') {
					// 	this.listActions.push({actionURL:'forceBackTask2', label:'Force to this point'});
					// } else if (this.task.taskType == 'TextToSpeech') {
					// 	this.listActions.push({actionURL:'forceBackTask2', label:'Force to this point'});
				} else if (this.task.taskType == 'ConcatenateAudio') {
					this.listActions.push({ actionURL: 'force500MilisecGap', label: 'Concatenate with 0.5 second gap' });
					this.listActions.push({ actionURL: 'force1SecGap', label: 'Concatenate with 1 second gap' });
					this.listActions.push({ actionURL: 'forceBackTask2', label: 'Force to this point' });
				} else {
					this.listActions.push({ actionURL: 'forceBackTask2', label: 'Force to this point' });
				}
			}

			if (this.task.taskType == 'AISubtitleReview') {
				this.listActions.push({ actionURL: 'addHumanSubtitleReview', label: 'Add Human Subtitle Review' });
			}

			// Plan #33 fase 4: sequential review chain actions
			if (this.task.taskType == 'GenericReview') {
				this.listActions.push({ actionURL: 'addSequentialReview', label: 'Add review after this one' });
				if (this.task.status == 'On-Hold') {
					this.listActions.push({ actionURL: 'editReviewers', label: 'Edit reviewers' });
					// Chain reviews inserted after an already-finished link have no
					// status transition left to auto-activate them — offer a starter.
					let taskData: any = {};
					try { taskData = JSON.parse(this.task.data || '{}'); } catch { }
					if (taskData.sequentialReview) {
						this.listActions.push({ actionURL: 'activateReview', label: 'Activate review' });
					}
				}
			}
		}

		if (this.task.taskType == 'GenericReview' || this.task.taskType == 'TranslationReview') {
			const data = JSON.parse(this.task.data);
			const sortedData = this.sortObjectKeysAlphabetically(data);

			for (var metadataKey in sortedData) {
				if (sortedData.hasOwnProperty(metadataKey)) {
					if (['emailPoweredBy', 'emailFromName', 'userLocale', 'emailBody', 'hideSmartDocsList', 'emailFooter', 'fixTitle'].includes(metadataKey)) {
						continue;
					}
					var metadataValue = sortedData[metadataKey];
					if (['urlFix'].includes(metadataKey)) {
						const label = sortedData.hasOwnProperty('fixTitle') ? sortedData['fixTitle'] : 'REVIEW';
						this.listTaskDetails.push({ type: 'link', key: null, value: null, label: label, url: metadataValue, list: null });
					} else {
						if (['arrPrompts', 'arrLanguages', 'arrForcedTask', 'arrForcedBackTask'].includes(metadataKey)) {
							// const data2 = JSON.parse( metadataValue );
							var list: KVType[] = [];

							for (let i = 0; i < metadataValue.length; i++) {
								const element = metadataValue[i];

								for (var metadataKey2 in element) {
									console.log(metadataValue);

									if (element.hasOwnProperty(metadataKey2)) {
										var metadataValue2 = element[metadataKey2];
										var metadataValue3 = JSON.stringify(metadataValue2);
										list.push({ key: metadataKey2, value: metadataValue3 });
									}
								}
							}
							this.listTaskDetails.push({ type: 'text', key: metadataKey, value: '', label: null, url: null, list: null });
							this.listTaskDetails.push({ type: 'list', key: null, value: null, label: null, url: null, list: list });
						} else {
							this.listTaskDetails.push({ type: 'text', key: metadataKey, value: metadataValue, label: null, url: null, list: null });
						}
					}
				}
			}

			this.listTaskDetails = this.listTaskDetails.sort((a, b) => {
				if (a.type === 'link' && b.type === 'text') return -1;
				if (a.type === 'text' && b.type === 'link') return 1;
				return 0;
			});
		} else {
			const data = JSON.parse(this.task.data);
			const sortedData = this.sortObjectKeysAlphabetically(data);

			for (var metadataKey in sortedData) {
				if (sortedData.hasOwnProperty(metadataKey)) {
					var metadataValue = sortedData[metadataKey];

					if (['arrPrompts', 'arrLanguages', 'arrForcedTask', 'arrForcedBackTask'].includes(metadataKey)) {
						// const data2 = JSON.parse( metadataValue );
						var list: KVType[] = [];

						for (let i = 0; i < metadataValue.length; i++) {
							const element = metadataValue[i];

							for (var metadataKey2 in element) {
								console.log(metadataValue);

								if (element.hasOwnProperty(metadataKey2)) {
									var metadataValue2 = element[metadataKey2];
									var metadataValue3 = JSON.stringify(metadataValue2);
									list.push({ key: metadataKey2, value: metadataValue3 })
								}
							}
						}
						this.listTaskDetails.push({ type: 'text', key: metadataKey, value: '', label: null, url: null, list: null });
						this.listTaskDetails.push({ type: 'list', key: null, value: null, label: null, url: null, list: list });
					} else {
						this.listTaskDetails.push({ type: 'text', key: metadataKey, value: metadataValue, label: null, url: null, list: null });
					}
				}
			}
			this.detailsName = this.task.taskName;
			this.detailsResources = this.task.resources;
		}
		// Get Users
		this.detailsResources.forEach((resource) => {
			if (resource.owner) {
				resource.people = {
					dataName: resource.people.dataName,
					photo: resource.people.photo
				};
			}
			// resource.people = {
			// 	dataName: resource.people.dataName,
			// 	photo: resource.people.photo
			// };
		});
		// console.log('Users:', this.task.resources);
		this.form.controls.users.setValue(this.task.resources);
	}

	sortObjectKeysAlphabetically(obj: Record<string, any>): Record<string, any> {
		const sortedKeys = Object.keys(obj).sort((a, b) => a.localeCompare(b));
		const sortedObj: Record<string, any> = {};

		for (const key of sortedKeys) {
			sortedObj[key] = obj[key];
		}

		return sortedObj;
	}

	openURL(url) {
		console.log(url);
		const newTab = window.open(url, '_blank');
	}

	filterSmartdocs() {
		this.listFileSmartDocs = this.task.listSmartDocs.filter((value) => {
			return value.category == 'file';
		}).sort((a1, a2) => {
			if (a1.fileName < a2.fileName) {
				return -1;
			} else if (a1.fileName > a2.fileName) {
				return 1;
			} else {
				return 0;
			}
		});

		this.listDeliveryfileSmartDocs = this.task.listSmartDocs.filter((value) => {
			return value.category == 'deliveryfile';
		}).sort((a1, a2) => {
			if (a1.fileName < a2.fileName) {
				return -1;
			} else if (a1.fileName > a2.fileName) {
				return 1;
			} else {
				return 0;
			}
		});

		this.listAllSmartDocs = this.task.listSmartDocs.sort((a1, a2) => {
			if (a1.fileName < a2.fileName) {
				return -1;
			} else if (a1.fileName > a2.fileName) {
				return 1;
			} else {
				return 0;
			}
		});
	}

	clickAction(actionURL) {
		// console.log(actionURL);

		const funcion = this.funcionesService[actionURL];
		if (typeof funcion === "function") {
			funcion.call(this.funcionesService, this.task, this);
		} else {
			console.log("La función no existe: " + actionURL);
		}
	}

	status = {
		'Completed': {
			// color: 'text-green-600',
			text: 'Completed',
			icon: 'done'
		},
		'Active': {
			// color: 'text-blue-600',
			text: 'Active',
			icon: 'settings'
		},
		'On-Hold': {
			// color: 'text-yellow-600',
			text: 'Pending',
			icon: 'timer'
		},
		'Cancelled': {
			text: 'Cancelled',
			icon: 'block'
		},
		'Failed': {
			text: 'Failed',
			icon: 'error'
		},
	}

	// UX SECTION
	returnTaskDetailValue(element) {
		// console.log('parseValue', element);
		if (typeof element === 'object') {
			element = JSON.stringify(element);
			return element;
		} else {
			return element;
		}
	}
	isObject(element): boolean {
		// console.log('el-1', element);

		if (typeof element === undefined || typeof element === null) {
			return false;
		} else if (typeof element === 'object') {
			return true;
		}

		let parseable;
		try {
			JSON.parse(element);
			parseable = true;
		} catch {
			return false;
		}

		// console.log('el-2 parseable', parseable);

		let parsedElement = JSON.parse(element);
		// console.log('el-3 parsedElement', parsedElement);
		if (parsedElement === null) {
			return false;
		}
		if (typeof parsedElement === 'object') {
			// console.log('el-4 typeof parsedElement', typeof parsedElement);
			return true
		} else {
			return false
		}
	}

	// parseValue(value: string): { key: string; value: any }[] {
	// 	let parsedValue: { key: string; value: any }[] = [];
	// 	try {
	// 		if (value) {
	// 			parsedValue = JSON.parse(value);
	// 			console.log('parsedValue', parsedValue);
	// 		}
	// 	} catch (error) {
	// 		console.error('Error parsing value:', error);
	// 		// Handle the error as needed, e.g., return an empty array or a specific error message
	// 		return [];
	// 	}

	// 	console.log('parsedValue', parsedValue);

	// 	return parsedValue;
	// }

	// deepParse(input: any): any {
	// 	input = JSON.parse(input);
	// 	if (typeof input === 'string') {
	// 		try {
	// 			const parsed = JSON.parse(input);
	// 			return this.deepParse(parsed);
	// 		} catch {
	// 			return input;
	// 		}
	// 	} else if (Array.isArray(input)) {
	// 		return input.map(item => this.deepParse(item));
	// 	} else if (input && typeof input === 'object') {
	// 		const result: any = {};
	// 		for (const [key, value] of Object.entries(input)) {
	// 			result[key] = this.deepParse(value);
	// 		}
	// 		return result;
	// 	}
	// 	return input;
	// }


	parseValue(value: string) {
		// console.log('parseValue', value);
		if (typeof value === 'object') {
			return value;
		} else if (typeof value === 'string') {
			try {
				return JSON.parse(value);
			} catch (error) {
				return [];
			}
		}
	}

	onUsersChange(event: UserChangeEvent) {
		this.loadingService.loading = true;

		// Handle added users
		if (event.addedUserIds.length > 0) {
			this.apiService.addTaskUsers(this.task.id, event.addedUserIds)
				.pipe(takeUntilDestroyed(this.destroyRef))
				.subscribe({
					next: () => {
						// Fetch user details and add to UI
						const userRequests = event.addedUserIds.map(id => this.apiService.getUser(id));
						forkJoin(userRequests).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
							next: (users: any[]) => {
								users.forEach(user => {
									const resourceUser = this.convertUserData(user);
									this.userCirclesComponent?.addUserToList(resourceUser);
								});
								this.loadingService.loading = false;
							},
							error: () => {
								this.loadingService.loading = false;
							}
						});
					},
					error: (err) => {
						const message = err?.status === 403
							? 'You do not have permission to add users to this task.'
							: err?.status === 404
								? 'Task not found.'
								: 'Error adding users.';
						this.snackBar.open(message, 'Dismiss', { duration: 4000 });
						this.loadingService.loading = false;
					}
				});
		}

		// Handle removed users
		if (event.removedUserIds.length > 0) {
			this.apiService.deleteTaskUsers(this.task.id, event.removedUserIds)
				.pipe(takeUntilDestroyed(this.destroyRef))
				.subscribe({
					next: () => {
						this.userCirclesComponent?.removeUsersFromList(event.removedUserIds);
						this.loadingService.loading = false;
					},
					error: (err) => {
						const message = err?.status === 403
							? 'You do not have permission to remove users from this task.'
							: err?.status === 404
								? 'Task not found.'
								: 'Error removing users.';
						this.snackBar.open(message, 'Dismiss', { duration: 4000 });
						this.loadingService.loading = false;
					}
				});
		}
	}

	private convertUserData(input: any): ResourceUser {
		return {
			id: input.id,
			labelName: `${input.firstName} ${input.lastName}`,
			dataName: `${input.firstName}, ${input.organization.name}`,
			nameComposed: `${input.firstName} ${input.lastName}`,
			name: input.firstName,
			photo: input.photo,
			email: input.email,
			orgLogo: input.organization.logo,
			orgName: input.organization.name,
			orgId: input.organization.id,
			orgWeb: "",
			visibleInTask: input.canAccessTasks
		};
	}
}
